import { IInventoryPage } from '../../../inventory-page.interface';


export const UPLOAD_POD_EDIT_PAGE: IInventoryPage = {
	'route': '/upload/pod/edit',
	'title': 'Edit',
	'uiReference': [
		'Crossbody Bag (crossbody_bag, CROSSBODY_BAG, cross body bag, cross-body bag) is supported in the Merch by Amazon (MBA) listing editor and FLAI AI setup.',
		'Crossbody Bag supports the US marketplace, Front printing, a 1200 × 750 pixel upload area, and Black or Stone colors. It is an accessory with no clothing fit-type selection.',
		'To configure Crossbody Bag, open a design in Edit Designs, choose Merch by Amazon, and select Crossbody Bag from the product selector. Set its Front print, supported color, and US marketplace options, then Save.',
		'For FLAI AI setup, include MBA and check Crossbody Bag in the setup product selection, or choose All under Products. Previously remembered product selections may exclude newly added products. Include the US marketplace.',
		'Crossbody Bag is included in the AI setup catalog, but selection does not guarantee a recommendation. Strict mode may skip unsuitable artwork; printable-surface and color-contrast decisions can also exclude it. Read the completion report for the actual reason instead of assuming the product is unsupported.',
		'The FLAI chat sidebar can guide Crossbody Bag setup and use the actions exposed by the current page, such as opening Edit Designs or exporting an upload batch. Chat has no tool to change or save product settings. AI setup in the editor is a separate workflow; batch export does not publish to Amazon.',
		'Edit Settings',
		'Shortcut Guide',
		'Add designs Import Listings & Images',
		'Listing editor',
		'Previous design',
		'Design Tag',
		'Next design',
		'Scripted Replace',
		'Design tags /3',
		'Listing status',
		'Tagging actions',
		'Restore Default Options',
		'Advanced Options',
		'Load',
		'Clear',
		'Read More',
		'Clear Filters',
		'Back to Designs',
		'Back to Edit',
		'Back to Profiles',
		'Save',
		'Back To Designs',
		'Back To Edit',
		'Edit Languages',
		'Title',
		'Description',
		'Keywords',
		'KW Finder',
		'KW Workbench',
		'Men',
		'Women',
		'Youth',
		'Black',
		'White',
		'Colorful',
		'FLYING',
		'UPLOAD',
		'Add / Edit Languages',
		'Types',
		'Color',
		'Previous products',
		'Next products',
		'price',
		'Fit Type',
		'Girls',
		'Adult Unisex',
		'Print',
		'Preview',
		'Maximum of colors are selected',
		'Auto Translate',
		'Bulletpoint 1',
		'Bulletpoint 2',
		'Public',
		'Private',
		'Live',
		'Draft',
		'Products',
		'Colors',
		'Background Color',
		'Marketplaces & Prices',
		'AutoTranslate Title',
		'Brand',
		'Availability',
		'Publish',
		'Collection',
		'Categories',
		'Illustration',
		'Photography',
		'Background',
		'Artwork Type',
		'notes-pod works!',
		'Create Listings For Your Designs',
		'Add Designs',
		'Load Designs',
		'Quick Search',
		'Search designs',
		'Text Replace',
		'Current text',
		'New text',
		'Replace',
		'This option will give you ability to replace all the matched text the by keeping with existing format of the text',
		'This option will give you ability to replace all matched text that start with given text',
		'This option will give you ability to replace all matched text that end with given text',
		'This option will give you ability to replace all matched text that matched with given text.',
		'This option will give you ability to replace all matched text that exactly matched with given text.',
		'Placeholder / old',
		'from',
		'Replace All',
		'Replace Selected',
		'ID:',
		'Open translation options',
		'Translate to All',
		'Translate from',
		'Search text',
		'TM Listing Check',
		'Check Current Listing',
		'Check All Listing',
		'Check Blacklist',
		'TM Search',
		'Search',
		'Translate text to',
		'Actions',
		'Translation',
		'Settings',
		'Includes'
	],
	'sources': [
		'apps/flying-projects/shared/src/constants/upload/app-constants/platforms/merch-by-amazon/mba-products.constants.ts',
		'apps/flying-projects/shared/src/constants/upload/app-constants/platforms/merch-by-amazon/mba-colors.constants.ts',
		'apps/flying-projects/backend/server-live/src/controllers/upload/ai-listing/prompters/mba-setup-prompter.ts',
		'apps/flying-projects/backend/server-live/src/controllers/upload/ai-listing/helpers/mba-setup-resolver.helper.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/edit-pod/shared/pod-ai-setup-modal/pod-ai-setup-modal.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/services/shared/agent/upload-workflow-page.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/edit-pod/edit-pod-routing.module.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/edit-pod/edit-pod.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/edit-pod/edit-pod.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/shared/data-import/data-import.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/shared/data-import/data-import.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/shared-components/edit-page/edit-components/navigation-bar/navigation-bar.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/shared-components/edit-page/edit-components/navigation-bar/navigation-bar.data.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/shared-components/edit-page/edit-components/navigation-bar/navigation-bar.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/shared-components/edit-page/edit-components/design-list/design-list.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/shared-components/edit-page/edit-components/design-list/design-list.data.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/shared-components/edit-page/edit-components/design-list/design-list.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/edit-pod/edit-views/global/global.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/edit-pod/edit-views/global/global.data.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/edit-pod/edit-views/global/global.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/edit-pod/edit-views/mba/mba.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/edit-pod/edit-views/mba/mba.data.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/edit-pod/edit-views/mba/mba.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/edit-pod/edit-views/displate/displate.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/edit-pod/edit-views/displate/displate.data.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/edit-pod/edit-views/displate/displate.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/edit-pod/edit-views/notes/notes.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/edit-pod/edit-views/notes/notes.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/shared-components/edit-page/edit-components/no-designs/no-designs.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/shared-components/edit-page/edit-components/no-designs/no-designs.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/shared-components/edit-page/edit-components/navigation-bar/sub-components/design-filter/design-filter.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/shared-components/edit-page/edit-components/navigation-bar/sub-components/design-filter/design-filter.data.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/shared-components/edit-page/edit-components/navigation-bar/sub-components/design-filter/design-filter.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/shared-components/edit-page/edit-components/navigation-bar/sub-components/text-replace/text-replace.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/shared-components/edit-page/edit-components/navigation-bar/sub-components/text-replace/text-replace.data.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/shared-components/edit-page/edit-components/navigation-bar/sub-components/text-replace/text-replace.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/shared-components/edit-page/edit-components/navigation-bar/sub-components/scripted-replace/scripted-replace.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/shared-components/edit-page/edit-components/navigation-bar/sub-components/scripted-replace/scripted-replace.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/shared-components/edit-page/edit-components/design-cards/design-card-element/design-card-element.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/shared-components/edit-page/edit-components/design-cards/design-card-element/design-card-element.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/shared-components/edit-page/edit-components/translate/translate-menu/translate-menu.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/shared-components/edit-page/edit-components/translate/translate-menu/translate-menu.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/shared-components/edit-page/design-upload-details/design-upload-details.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/shared-components/edit-page/design-upload-details/design-upload-details.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/shared-components/edit-page/edit-components/tm-option-tab/tm-option-tab.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/shared-components/edit-page/edit-components/tm-option-tab/tm-option-tab.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/edit-pod/edit-views/mba/product-preview/mba-clothing-view/mba-clothing-view.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/edit-pod/edit-views/mba/product-preview/mba-clothing-view/mba-clothing-view.data.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/edit-pod/edit-views/mba/product-preview/mba-clothing-view/mba-clothing-view.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/edit-pod/edit-views/mba/product-preview/mba-accessories-view/mba-accessories-view.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/edit-pod/edit-views/mba/product-preview/mba-accessories-view/mba-accessories-view.data.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/edit-pod/edit-views/mba/product-preview/mba-accessories-view/mba-accessories-view.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/shared-components/edit-page/edit-components/navigation-bar/sub-components/scripted-replace/scripted-replace-suggestions/scripted-replace-suggestions.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/shared-components/edit-page/edit-components/navigation-bar/sub-components/scripted-replace/scripted-replace-suggestions/scripted-replace-suggestions.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/shared-components/edit-page/edit-components/translate/translate-dropdown/translate-menu-dropdown.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/shared-components/edit-page/edit-components/translate/translate-dropdown/translate-menu-dropdown.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/edit-pod/edit-views/mba/product-preview/shared/hover-product-preview/hover-product-preview.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/edit-pod/edit-views/mba/product-preview/shared/hover-product-preview/hover-product-preview.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/edit-pod/edit-views/mba/product-preview/shared/click-product-preview/click-product-preview.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/edit-pod/edit-views/mba/product-preview/shared/click-product-preview/click-product-preview.component.html'
	],
	'aliases': [
		'Edit Pod'
	]
};
